<form class="bbva-content" #formFlap id="formFlap" name="formulrio" ngNoForm method="POST" [action]="bbvaPostUrl">
    <div class="bbva-header">
    </div>
    <mat-dialog-content>
       <div class="d-flex align-items-center justify-content-center mb-4">
            <img src="./assets/icons/payment_methods/bbvamulti.svg" class="mr-2" alt="bbva logo" height="30">
            <img src="./assets/icons/padlock.svg" alt="padlock" height="15">
        </div> 
        <div>
            <p class="mb-0 text-size-2 color-black">Serás redirigido a la plataforma <span
                    class="color-omicron text-size-1">Multipagos de BBVA</span> donde podrás realizar tu pago con
                cualquiera de las siguientes opciones: tarjetas bancarias, cheque en línea (BBVA a BBVA), Transferencias
                SPEI
                o Practicaja. </p>
            <p class="mb-0 text-size-2 color-black">Tras esta operación tu pedido
                se habrá realizado con éxito.</p>
        </div>

        <div class="d-none">
            <input name="mp_account" value="{{mpAccount}}"><br>
            <input name="mp_product" value="1"><br>
            <input name="mp_order" value="{{order}}"><br>
            <input name="mp_reference" value="{{reference}}"><br>
            <input name="mp_node" value="0"><br>
            <input name="mp_concept" value="1"><br>
            <input name="mp_amount" value="{{amount}}"><br>
            <input name="mp_customername" value="{{customerName}}"><br>
            <input name="mp_currency" value="1"><br>
            <input name="mp_signature" value="{{hash}}"><br>
            <input name="signature_copy" value="{{hash}}"><br>
            <input name="mp_urlsuccess" value="{{successUrl}}"><br>
            <input name="mp_urlfailure" value="{{failureUrl}}">
            <input name="cardcode" value="{{cardCode}}">
            <input name="dxpTransactionId" value="{{transactionId}}">
            <input name="mp_datereference" value="{{dateReference}}">

            <input name="mp_promo" value="{{promotions}}">
            <input name="mp_promo_msi" value="{{promotionsMSI}}">
            <input name="mp_paymentmethod" value="{{paymentMethods}}">
            <input name="mp_sbtoken" value="{{token}}">
            <input name="mp_registersb" value="1">
            
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="d-flex flex-column">
        <button [disabled]="disabledButtons" mat-raised-button type="submit" color="primary" #payButton id="payButton"
            class="font-omicron-bold blue-button font-size-button width-100 mb-2">
            Pagar con Multipagos
        </button>
        <button [disabled]="disabledButtons" mat-stroked-button class="white-button width-100 ml-0 mb-2" type="button" color="primary" (click)="selectCard()" *ngIf="includesPaymentCard">
            Pagar con tarjeta
        </button>
        <button [disabled]="disabledButtons" mat-stroked-button class="white-button width-100 ml-0 mb-2" type="button" color="primary" (click)="close()">
            Cancelar
        </button>
    </mat-dialog-actions>
</form>